export default __webpack_public_path__ + "static/media/hht2_ani_07.28f6ac68.png";